export const PLAN_FEATURES: Record<string, string[]> = {
    basic: [
        "Admin Dashboard",
        "Employees List",
        "Employees",
        "Dashboard",
        "Leaves",
        "Designations",
        "Leaves (Admin)",
        "Calendar",
        "Attendance",
        "Departments",
        "Reports",
        "Attendance (Admin)",
        "Financial Year Settings",
        "Loan Requests",
        "Passbook / Statement",
        "Settings & Policies",
        "TDS Slab",
        "Skill",
        "Surcharge & Cess Settings",
        "Tax Regime Configuration",
        "TDS",
        "Roles",
        "Users",
        "User Management",
        "Payroll Component",
        "Employee Salary",
        "Employee Salary Structure",
        "Payroll",
        "Provident Fund",
        "Payments",
        "Budget Revenues",
        "Budget Expenses",
        "Budgets",
        "Accounting",
        "Configuration",
        "ESIC Components",
        "EPF Dashboard",
        "Tax Section",
        "Roles & Permissions",
        "Declaration Form",
        "TDS Dashboard",
        "Withdrawal Requests",
        "Email Configuration",
        "Employee Contribution",
        "Employee Mapping",
        "Reimbursement",
        "Expense Categories",
        "Weekly Off",
        "Experience",
        "Branch",
        "Holidays",
        "Leave Types",
    ],

    standard: [
        // BASIC
        "Admin Dashboard",
        "Employees List",
        'Request Dashboard',
        "Employee Dashboard",
        "Employees",
        "Dashboard",
        "Leaves",
        "Designations",
        "Leaves (Admin)",
        "Calendar",
        "Attendance",
        "Departments",
        "Reports",
        "Attendance (Admin)",
        "Financial Year Settings",
        "Add Company",
        "Email Configuration",
        "Loan Requests",
        "Passbook / Statement",
        "Settings & Policies",
        "TDS Slab",
        "Skill",
        "Surcharge & Cess Settings",
        "Tax Regime Configuration",
        "TDS",
        "Roles",
        "Users",
        "User Management",
        "Payroll Component",
        "Employee Salary",
        "Employee Salary Structure",
        "Payroll",
        "Provident Fund",
        "Payments",
        "Budget Revenues",
        "Budget Expenses",
        "Expense Categories",
        "Budgets",
        "Accounting",
        "Shift",
        "Configuration",
        "EPF Dashboard",
        "Branch",
        "Employee Mapping",
        "Reimbursement",
        "Holidays",
        "Leave Types",

        // STANDARD ONLY
        "Leaves (Employee)",
        "Roles & Permissions",
        "Leave Encashment",
        "Work From Home",
        "ESIC Components",
        "Tax Section",
        "Declaration Form",
        "TDS Dashboard",
        "Loan Requests",
        "Withdrawal Requests",
        "Weekly Off",
        "Experience",
    ],

    professional: [
        // BASIC
        "Admin Dashboard",
        "Employees List",
        "Employee Dashboard",
        'HR Dashboard',
        "Employees",
        "Dashboard",
        "Leaves",
        "Designations",
        "Leaves (Admin)",
        "Calendar",
        "Attendance",
        "Departments",
        "Reports",
        "Attendance (Admin)",
        "Financial Year Settings",
        "Add Company",
        "Email Configuration",
        "Loan Requests",
        "Passbook / Statement",
        "Settings & Policies",
        "TDS Slab",
        "Skill",
        "Surcharge & Cess Settings",
        "Tax Regime Configuration",
        "TDS",
        "Roles",
        "Users",
        "User Management",
        "Payroll Component",
        "Employee Salary",
        "Employee Salary Structure",
        "Payroll",
        "Provident Fund",
        "Payments",
        "Budget Revenues",
        "Budget Expenses",
        "Budgets",
        "Accounting",
        "Shift",
        "Configuration",
        "Reimbursement",
        "Expense Categories",

        // STANDARD
        "Leaves (Employee)",
        "Roles & Permissions",
        "Leave Encashment",
        "Work From Home",

        // PROFESSIONAL ONLY
        "ESIC",
        "Employee Contribution",
        "Monthly Contributions",
        "Clients",
        "Training",
        "Promotion",
        "Resignation",
        "Termination",
        "EPF Dashboard",
        "Tax Section",
        "Declaration Form",
        "TDS Dashboard",
        "Loan Requests",
        "Withdrawal Requests",
        "Branch",
        "Employee Mapping",
        "Vendor",
        "Weekly Off",
        "Experience",
        "Holidays",
        "Leave Types",
    ],

    enterprise: ["*"]
};
